import { Countries } from '@xoda/common'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { gymState } from '../../store/gym'
import s from './Amount.module.css'

const Amount: FC<AmountProps> = (props) => {
  const { items, total = 0 } = props

  const { t } = useTranslation()

  const [gym] = useRecoilState(gymState)

  return (
    <div className={s.root}>
      {items && (
        <table className={s.items}>
          <caption className={s.caption}>{t('Payment summary')}</caption>
          <tbody>
            {items.map((item) => (
              <tr key={item.name}>
                <th scope="row" className={s.name}>
                  {item.name}
                </th>
                <td>${item.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className={s.total}>
        {t('Total: {{amount}}', {
          amount: Countries.formatAmount(
            items ? items.reduce((pool, item) => pool + item.price, 0) : total,
            gym?.currency_code,
            true
          ),
        })}
      </div>
    </div>
  )
}

type AmountProps = {
  items?: { name: string; price: number }[]
  total?: number
}

export { Amount }
export type { AmountProps }
